import styles from './Initials.module.scss';

const Initials = ({ context }) => {
  return (
    <span className={styles.root}>
      <input
        type='text'
        aria-label='initials'
        placeholder='Initials'
        pattern={`^${context.initials}$`}
        required={true}
      />
    </span>
  );
};

export default Initials;